/**
 * Minimal dotted-version comparison for the force-update gate. Not full semver —
 * pre-release tags are ignored; only the numeric x.y.z segments are compared.
 */
export function compareVersions(a: string, b: string): number {
  const pa = a.split('.').map((n) => parseInt(n, 10) || 0);
  const pb = b.split('.').map((n) => parseInt(n, 10) || 0);
  const len = Math.max(pa.length, pb.length);
  for (let i = 0; i < len; i++) {
    const diff = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (diff !== 0) return diff < 0 ? -1 : 1;
  }
  return 0;
}

/** True when `current` is strictly older than `min`. */
export function isBelow(current: string, min: string): boolean {
  return compareVersions(current, min) < 0;
}
